"use client";

import { Stub } from "@/composites/_internal";

/**
 * STUB — replaced in a subsequent ticket. See `docs/PDP_V2_ARCHITECTURE.md` §4.
 *
 * Intent: Bottom-fixed CTA bar pinned past summary. STORE-005.
 */
export function StickyCartBar() {
	return (
		<Stub
			name="cart/StickyCartBar"
			intent="Bottom-fixed CTA bar pinned past summary. STORE-005."
		/>
	);
}
